import React from 'react';
import './index.css';
import clsx from 'classnames';

const DataDisplay = () => {
  const displayList = [
    '/img/wenjian.png',
    '/img/yangpin.png',
    '/img/liulan.png',
    '/img/daochu.png',
    '/img/peizhi.png',
    '/img/yewu.png',
  ];

  return (
    <div className={clsx('intelligence-data')}>
      <div className={clsx('intelligence-data-title')}>多元化数据管理</div>
      <div className={clsx('intelligence-data-content')}>
        <div className={clsx('intelligence-data-content-display')}>
          <img src='/img/data.png' alt='' width={'70%'} height={'70%'} />
          <div className={clsx('intelligence-data-content-text')}>
            Detection Management System
          </div>
          <div className={clsx('intelligence-data-content-display-list')}>
            {displayList?.map((v, index) => {
              return (
                <div
                  className={clsx(
                    'intelligence-data-content-display-list-item',
                  )}
                  key={index}
                >
                  <img
                    src='/img/down.png'
                    alt=''
                    width={'20%'}
                    height={'20%'}
                  />
                  <img src={v} alt='' width={'80%'} height={'80%'} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataDisplay;
